import { render, staticRenderFns } from "./ReceiptPeriodDetail.vue?vue&type=template&id=c00a1a5a"
import script from "./ReceiptPeriodDetail.vue?vue&type=script&lang=ts"
export * from "./ReceiptPeriodDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports